import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=7ac66a45&scoped=true&"
import script from "./DataCard.vue?vue&type=script&lang=js&"
export * from "./DataCard.vue?vue&type=script&lang=js&"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=7ac66a45&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac66a45",
  null
  
)

export default component.exports